const initTimeline = () => {
  const showCount = 5;
  const timelineItems = document.querySelectorAll('.timeline-item');
  const timelineButton = document.querySelectorAll(
    '.show-timeline-item__content',
  );

  if (timelineButton.length > 0 && timelineItems.length > 0) {
    timelineButton.forEach((button) => {
      button.addEventListener('click', function (event) {
        button.classList.toggle('timeline-open');
        const buttonID = button.getAttribute('data-id');

        const timelineItemContainer = document.querySelector(
          '.timeline-item__container[data-id="' + buttonID + '"]',
        );
        timelineItemContainer.classList.toggle(
          'timeline-item__container--open',
        );
      });
    });

    const showItems = () => {
      let count = 0;
      timelineItems.forEach((timelineItem, index) => {
        if (count < showCount) {
          timelineItem.setAttribute('data-visible', true);
          count++;
        } else {
          timelineItem.setAttribute('data-visible', false);
        }
      });
    };

    showItems();
  }
};

export default initTimeline;
